import { render, staticRenderFns } from "./PaymentRequisitionDetailDrawer.vue?vue&type=template&id=1c196ba2&"
import script from "./PaymentRequisitionDetailDrawer.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionDetailDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports